import { render, staticRenderFns } from "./OrdensServicoEdicao.vue?vue&type=template&id=2ab5edc7&scoped=true&"
import script from "./OrdensServicoEdicao.vue?vue&type=script&lang=js&"
export * from "./OrdensServicoEdicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5edc7",
  null
  
)

export default component.exports